'use client';

import { GetRecViewQuery, RelatedRecsQuery } from 'shared/__generated__/graphql';
import RecView from './-rec-view';

type RecViewProps = {
  id: string;
  initialRecData?: GetRecViewQuery['rec'];
  initialRelatedRecsData?: RelatedRecsQuery;
};

export default function RecViewPageContainer({
  id,
  initialRecData,
  initialRelatedRecsData,
}: RecViewProps) {
  return (
    <div className="flex justify-center p-0 md:p-[24px] overflow-x-hidden">
      <div className="flex flex-col gap-[24px] w-full mb-[100px]">
        <RecView
          id={id}
          initialRecData={initialRecData}
          initialRelatedRecsData={initialRelatedRecsData}
        />
      </div>
    </div>
  );
}
